<template>
  <div class="detail-page">
    <div class="detail-filter">
      <div class="filter-fields">
        <div class="filter-field">
          <el-select v-model="queryData.dataType" placeholder="数据类型" size="small">
            <el-option label="全部" value="0"></el-option>
            <el-option label="训练计划" value="1"></el-option>
            <el-option label="单课" value="2"></el-option>
          </el-select>
        </div>
        <div class="filter-field">
          <el-select v-model="queryData.completedStatus" placeholder="完成状态" size="small">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="未完" value="0"></el-option>
            <el-option label="已完" value="1"></el-option>
          </el-select>
        </div>
        <div class="filter-field">
          <el-select v-model="queryData.isDelete" placeholder="是否删除" size="small">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="未删" value="0"></el-option>
            <el-option label="已删" value="1"></el-option>
          </el-select>
        </div>
      </div>
      <div class="filter-actions">
        <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
        <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
      </div>
    </div>

    <!-- 列表 -->
    <div class="table-section">
      <div class="table-container" ref="tableContainer">
        <el-table
          :data="dataList"
          class="detail-table"
          :height="tableHeight"
          :header-cell-style="tableHeaderStyle"
          :cell-style="tableCellStyle"
          @sort-change="handleSortChange">
          <el-table-column type="expand" width="50">
            <template slot-scope="props">
              <el-table :data="props.row.list" height="300" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center',padding: '0' }">
                <el-table-column prop="trainDate" label="训练日期" sortable></el-table-column>
                <el-table-column prop="trainDate" label="第几周" sortable>
                  <template slot-scope="propsSub">
                    第{{propsSub.row.weekId}}周
                  </template>
                </el-table-column>
                <el-table-column prop="trainDate" label="第几周" sortable>
                  <template slot-scope="propsSub">
                    第{{propsSub.row.dayId}}天
                  </template>
                </el-table-column>
                <el-table-column prop="courseId" label="课程编号" sortable></el-table-column>
                <el-table-column prop="completedStatus" label="完成状态" sortable>
                  <template slot-scope="props">
                    <span v-if="props.row.completedStatus == 0">未完成</span>
                    <span v-if="props.row.completedStatus == 1">已完成</span>
                  </template>
                </el-table-column>
                <el-table-column prop="completedPercentage" label="完成百分比" sortable>
                  <template slot-scope="props">
                    {{props.row.completedPercentage}}%
                  </template>
                </el-table-column>
                <el-table-column prop="isDelete" label="训练时长" sortable>
                  <template slot-scope="props">
                    <span v-if="props.row.isDelete == 0">未删除</span>
                    <span v-if="props.row.isDelete == 1">已删除</span>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="trainPlanOrderid" label="训练单号" min-width="180" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="startDate" label="开始日" min-width="140" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="dataType" label="训练类型" min-width="120" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              <span v-if="props.row.dataType == 1">训练计划</span>
              <span v-if="props.row.dataType == 2">单课程</span>
            </template>
          </el-table-column>
          <el-table-column prop="dataId" label="训练计划编号/课程编号" min-width="180" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="completedStatus" label="完成状态" min-width="120" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              <span v-if="props.row.completedStatus == 0">未完成</span>
              <span v-if="props.row.completedStatus == 1">已完成</span>
            </template>
          </el-table-column>
          <el-table-column prop="completedPercentage" label="完成百分比" min-width="130" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.completedPercentage}}%
            </template>
          </el-table-column>
          <el-table-column prop="isDelete" label="删除状态" min-width="120" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              <span v-if="props.row.isDelete == 0">未删除</span>
              <span v-if="props.row.isDelete == 1">已删除</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="170" sortable="custom" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page_no"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="page_size"
        layout="total, prev, pager, next, sizes, jumper"
        :total="dataListnum || 0">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      queryData: {
        dataType: '0',
        completedStatus: '-1',
        isDelete: '-1',
        terminalUserId: ''
      },
      dataList: [],
      dataListnum: 0,
      tableHeight: 480,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: ''
    }
  },
  mounted () {
    this.$nextTick(this.initTableResizeObserver)
  },
  beforeDestroy () {
    this.destroyTableResizeObserver()
  },
  methods: {
    tableHeaderStyle () {
      return { textAlign: 'center', background: 'var(--aptus-surface-muted, #F5F6F8)', color: 'var(--aptus-text-secondary, #5E6670)', fontWeight: '600' }
    },
    tableCellStyle () {
      return { textAlign: 'center' }
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
      })
    },
    initTableResizeObserver () {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver () {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    LoadData (row) {
      this.queryData.terminalUserId = row.id
      this.TrainPlanMyList()
      this.TrainPlanMyNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.TrainPlanMyList()
      this.TrainPlanMyNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.TrainPlanMyList()
      this.TrainPlanMyNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.TrainPlanMyList()
      this.TrainPlanMyNum()
    },
    clickQuery () {
      this.page_no = 1
      this.TrainPlanMyList()
      this.TrainPlanMyNum()
    },
    clickQueryReset () {
      this.queryData.dataType = '0'
      this.queryData.completedStatus = '-1'
      this.queryData.isDelete = '-1'
      this.clickQuery()
    },
    TrainPlanMyList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.dataType = that.queryData.dataType
      data.completedStatus = that.queryData.completedStatus
      data.isDelete = that.queryData.isDelete
      data.terminalUserId = that.queryData.terminalUserId
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanMyList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainPlanMyNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.dataType = that.queryData.dataType
      data.completedStatus = that.queryData.completedStatus
      data.isDelete = that.queryData.isDelete
      data.terminalUserId = that.queryData.terminalUserId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanMyNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-page {
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

/* 筛选栏 */
.detail-filter {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: #FFFFFF;
  border: 1px solid #E2E6EC;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
  margin-bottom: 12px;
  flex-shrink: 0;
}

.filter-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field {
  min-width: 0;

  /deep/ .el-input,
  /deep/ .el-select {
    width: 160px;
  }
}

.filter-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #E2E6EC;
  overflow: hidden;
}

.detail-table {
  /deep/ .el-table__body td {
    padding: 10px 0;
    background: #FFFFFF;
    border-bottom: 1px solid #EFF1F5;
  }

  /deep/ .el-table__body tr:hover > td {
    background: #EFF6FF !important;
  }

  /deep/ .el-table__header th {
    padding: 10px 0;
    background: #F5F6F8 !important;
    border-bottom: 1px solid #E2E6EC;
    color: #5E6670;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #E2E6EC;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: #2563EB;
  border-color: #2563EB;
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: #3B82F6;
    border-color: #3B82F6;
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: #2563EB;
  background: #EFF6FF;
  border-color: #A8D0F5;

  &:hover {
    background: #2563EB;
    color: #FFF;
    border-color: #2563EB;
  }
}
</style>
